import { render, staticRenderFns } from "./AddSubjectLabelDialog.vue?vue&type=template&id=0df19124"
import script from "@/views/SubjectLabels/AddSubjectLabelDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/SubjectLabels/AddSubjectLabelDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/SubjectLabels/add-subject-label-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports